import { Form, Input, Button } from 'antd'
import { useDispatch } from 'react-redux';
import { loginUser } from '../../Redux/Actions/authActions';

const Login = () => {

    const dispatch = useDispatch()

    const onFinish = (values) => {
        console.log(values);
        dispatch(loginUser(values));
    }

    return (
        <div>
            <Form style={{
                width: '50%', margin: '10px auto', backgroundColor: 'transparent', padding: '10px', borderRadius: '10px', display: 'flex', flexDirection: 'column'
            }
            }
                name="basic"
                onFinish={onFinish}
            >
                <h1 style={{
                    display: 'flex', justifyContent: 'center'
                }}>Login Form</h1>
                <Form.Item
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your email!',
                        }, {
                            type: 'email',
                            message: 'Invalid Email'
                        }
                    ]}
                >
                    <Input placeholder='Enter your email here' style={{ width: '100%', borderRadius: '10px', fontSize: '20px' }} autoFocus />
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password!',
                        },
                    ]}
                >
                    <Input.Password placeholder='Bachay password here' style={{ width: '100%', borderRadius: '10px', fontSize: '20px' }} />
                </Form.Item>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', }}>
                    <Button type="primary" htmlType="submit" style={{ width: '40%', height: '50px', fontSize: '20px', borderRadius: '10px' }}
                    >
                        Submit
                    </Button>
                </div >
            </Form >
        </div >
    )
}

export default Login;

// import { Form, Input, Button } from 'antd'

// const Login = (props) => {

//     const onFinish = (values) => {
//         console.log(values);
//     }

//     return (
//         <div>
//             <Form style={{
//                 width: '100%', margin: '10px auto', backgroundColor: 'transparent', padding: '10px', borderRadius: '10px', display: 'flex', flexDirection: 'column'
//             }
//             }
//                 name="basic"
//                 onFinish={onFinish}
//                 requiredMark={false}
//                 autoComplete="off"
//             >
//                 <h1 style={{
//                     display: 'flex', justifyContent: 'center'
//                 }}>Login Form</h1>
//                 <Form.Item
//                     name="email"
//                     rules={
//                         [
//                             {
//                                 required: true,
//                                 message: 'Please input your email!',
//                             },
//                             {
//                                 type: 'email',
//                                 message: 'Please enter the valid email'
//                             }
//                         ]}
//                 >
//                     <Input placeholder='Enter your email here' style={{ width: '100%' }} />
//                 </Form.Item>

//                 <Form.Item
//                     name="password"
//                     rules={[
//                         {
//                             required: true,
//                             message: 'Please input your password!',
//                         },
//                     ]}
//                 >
//                     <Input.Password placeholder='Bachay password here' style={{ width: '100%' }} />
//                 </Form.Item>
//                 <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
//                     <Button type="primary" htmlType="submit" style={{ width: '80%' }}
//                     >
//                         Submit
//                     </Button>
//                 </div >
//             </Form>
//         </div >
//     )
// }

// export default Login